import React, { useState } from 'react';
import { coreUtils } from 'dealer-website-components';

const codeClassNames = 'builder-px-1.5 builder-py-0.5 builder-rounded builder-bg-slate-100 builder-text-slate-800 builder-text-[13px]';

export default function WysiwygEditorVariables({ showCampaignVariables }) {
  const [open, setOpen] = useState(false);
  const htmlVariables = coreUtils?.htmlVariables;

  if (!htmlVariables) return null;

  const names = Object.keys(htmlVariables).filter((name) => showCampaignVariables || !htmlVariables[name].campaign);

  return (
    <div className='builder-flex builder-flex-col builder-gap-3 builder-px-4 builder-py-3 builder-border-t builder-border-slate-200'>
      <button
        type='button'
        aria-expanded={open}
        onClick={() => setOpen((prevValue) => !prevValue)}
        className='builder-flex builder-items-center builder-self-start builder-gap-2 builder-py-1 builder-text-sm builder-font-semibold builder-text-primary hover:builder-opacity-80 focus:builder-outline-none focus-visible:builder-ring-2 focus-visible:builder-ring-primary builder-rounded'
      >
        <i className='fal fa-info-circle' />
        Variables you can use
        <i className={`fal fa-chevron-down builder-text-[11px] builder-transition-transform motion-reduce:builder-transition-none ${open ? 'builder-rotate-180' : ''}`} />
      </button>
      {open && (
        <div className='builder-flex builder-flex-col builder-gap-2.5 builder-max-w-4xl'>
          <p className='builder-text-sm builder-text-slate-600'>
            Type a variable in the HTML as <code className={codeClassNames}>{'{{variable_name}}'}</code>. On the website it is replaced with the real value.
          </p>
          <div className='builder-overflow-hidden builder-border builder-border-slate-200 builder-rounded-lg builder-divide-y builder-divide-slate-200'>
            {names.map((name) => (
              <div key={name} className='builder-flex builder-flex-wrap builder-items-start builder-gap-x-4 builder-gap-y-1 builder-px-3.5 builder-py-3'>
                <span className='builder-flex-shrink-0 builder-w-48'>
                  <code className={codeClassNames}>{`{{${name}}}`}</code>
                </span>
                <span className='builder-flex-1 builder-min-w-[14rem] builder-text-sm builder-text-slate-600'>
                  {htmlVariables[name].description}
                  {htmlVariables[name].date && (
                    <span className='builder-block builder-mt-1.5'>
                      Custom format: <code className={codeClassNames}>{`{{${name}:dd/mm}}`}</code> (use dd, mm, yyyy, yy)
                    </span>
                  )}
                </span>
                {htmlVariables[name].campaign && (
                  <span className='builder-flex-shrink-0 builder-px-2 builder-py-0.5 builder-text-[12px] builder-font-semibold builder-text-amber-800 builder-bg-amber-100 builder-rounded-full'>Advertisements with a campaign</span>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
